export default __webpack_public_path__ + "static/media/flag-cambodia.083ddc43.svg";